
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building-types/[slug]",
      function () {
        return require("private-next-pages/building-types/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building-types/[slug]"])
      });
    }
  